import React from "react";
import { Stack, Typography } from "@mui/material";
import { ExportDataTypeInclusionSelector } from "./ExportDataTypeInclusionSelector";
import {
  EXPORT_DATA_TYPES,
  EXPORT_INCLUSION_TYPES,
  EXPORT_RELATED_FILTERS,
} from "./types";
import { getCommonExportRatioOptions, getFilterRadioOption } from "./utils";
import { RadioOption } from "../RadioOptionsInput";
import { useProductFilterRenderer } from "./hooks/useProductFilterRenderer";

interface Props {
  inclusion: EXPORT_INCLUSION_TYPES;
  setInclusion: (value: EXPORT_INCLUSION_TYPES) => void;
  isBuyerIntentFilterEmpty: boolean;
  buyerIntentProductIds?: number[];
  setBuyerIntentProductIds?: (ids: number[]) => void;
}

export const BuyerIntentExportOptions: React.FC<Props> = ({
  inclusion,
  setInclusion,
  isBuyerIntentFilterEmpty,
  buyerIntentProductIds,
  setBuyerIntentProductIds,
}) => {
  const filterOption = getFilterRadioOption(
    EXPORT_DATA_TYPES.BUYER_INTENT,
    EXPORT_RELATED_FILTERS.BUYER_INTENT,
    isBuyerIntentFilterEmpty
  );
  const selectedOption: RadioOption = {
    label: "Include only selected products",
    value: EXPORT_INCLUSION_TYPES.SELECTED,
  };
  const [allOption, noneOption] = getCommonExportRatioOptions(
    EXPORT_DATA_TYPES.BUYER_INTENT
  );
  // Matches OppGen's exact wording (CustomizerTab.tsx): "Include all Buyer Intent data".
  const options = [
    filterOption,
    noneOption,
    { ...allOption, label: "Include all Buyer Intent data" },
    selectedOption,
  ];

  const renderOptionContent = useProductFilterRenderer(
    inclusion,
    buyerIntentProductIds ?? [],
    (ids) => setBuyerIntentProductIds?.(ids)
  );

  return (
    <Stack spacing={2} sx={{ width: "70%", paddingTop: "40px" }}>
      <Typography variant="h5" fontWeight={500} fontSize={16}>
        Buyer Intent
      </Typography>
      <ExportDataTypeInclusionSelector
        dataType={EXPORT_DATA_TYPES.BUYER_INTENT}
        options={options}
        inclusion={inclusion}
        setInclusion={setInclusion}
        renderOptionContent={renderOptionContent}
      />
    </Stack>
  );
};
